var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-sidebar-menu"},[_c('h-menu',{attrs:{"mode":"vertical","theme":"dark","accordion":"","collapse":!_vm.sidebar.opened,"width":"220px"}},[_c('sidebar-item',{attrs:{"routes":_vm.permission_routers}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdcf422","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/gtn/views/frame/Sidebar.vue
// module id = null
// module chunks = 